import useFeatureFlag from "hooks/useFeatureFlag";
import PersistDismissalFunctionality from "./helpers/PersistDismissalFunctionality";
import { Modal } from "./Modal";
import { Box, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";

type ImageAnnouncementModalProps = {
  imageUrl: string;
  featureFlagName: string;
  timesToDisappear?: number;
  redirectTo?: string;
};

const ImageModal = styled(Modal)({
  padding: 0,
  margin: 0,
  width: "auto",
  height: "auto",
  outline: "none",
  color: "white",
  ".MuiButtonBase-root": {
    color: "white",
  },
});

export default function ImageAnnouncementModal({
  imageUrl,
  featureFlagName,
  timesToDisappear = 1,
  redirectTo = "/retrievals/send-boxes",
}: ImageAnnouncementModalProps) {
  const { showComponent, dismissComponent } = PersistDismissalFunctionality({
    cookiesKey: `${featureFlagName} Modal`,
    timesToDisappear,
  });
  const { enabled: enabledFeature } = useFeatureFlag(featureFlagName);
  const navigate = useNavigate();

  const handleImageClick = () => {
    dismissComponent();
    navigate(redirectTo);
  };

  if (!enabledFeature) return null;

  return (
    <ImageModal
      open={showComponent}
      setOpen={() => {}}
      onClose={dismissComponent}
      style={{ padding: 0, margin: 0, width: "auto", height: "auto", outline: "none" }}
      buttonStyle={{ color: "white" }}
    >
      <Box width="auto" height="auto" display="flex">
        <img
          src={imageUrl}
          alt="Image Announcement"
          onClick={handleImageClick}
          style={{ cursor: "pointer", height: "450px", width: "auto" }}
        />
      </Box>
    </ImageModal>
  );
}
